import axiosInstance from "../api/axios";

export const getTnCPolicy = async (type) => {
  const res = await axiosInstance.get(`/api/admin/list-policy/${type}`);
  return res.data;
};

export const getCategories = async (type) => {
  const res = await axiosInstance.get(`/api/admin/list-category?type=${type}`);
  return res.data;
};

export const addFile = async (payload) => {
  const res = await axiosInstance.post(`/api/file/upload`, payload);
  return res.data;
};
export const deleteFile = (payload) => {
  const config = {};
  config.data = payload; // Axios uses 'data' for the request payload
  return axiosInstance.delete(`/api/file/delete`, config);
};

export const fetchAvgValue = async (payload) => {
  const res = await axiosInstance.post(
    `/api/user/fetch-avg?point=${payload?.endpoint}&city=${encodeURIComponent(
      payload.city
    )}&children=${payload?.children}&members=${payload?.members}&rent=${
      payload?.rent
    }`
  );
  return res.data;
};

export const toggleNotifications = async (payload) => {
  const res = await axiosInstance.post(
    `/api/user/toggle-notification`,
    payload
  );
  return res.data;
};

export const getToggleData = async () => {
  const res = await axiosInstance.get("/api/user/toggle-status");
  return res.data;
};
